import { useParams } from 'react-router-dom';
import * as web3 from "@solana/web3.js"
import { useEffect, useState } from 'react';
import { AdCampaign } from '../models/AdCampaign';
import { useProgram } from '../utils/ProgramContext';
import { AuctionRoom } from '../models/AuctionRoom';
import { Auction } from '../models/Auction';
import { BN } from '@coral-xyz/anchor';

function getTimestampInSeconds() {
    return Math.floor(Date.now() / 1000)
}

const IframeContent = () => {
    const { providerPda } = useParams<{ providerPda: string }>();

    const [auctionRoom, setAuctionRoom] = useState<AuctionRoom>()
    const [adCampaign, setAdCampaign] = useState<AdCampaign>()

    const { program } = useProgram() || {}


    useEffect(() => {
        async function fetchAuctionRoom() {
            if (!program || !providerPda) {
                return
            }

            const [auctionRoomPda] = AuctionRoom.findAddress(new web3.PublicKey(providerPda))
            const auctionRoomAccount = await program.account.auctionRoom.fetch(auctionRoomPda)
            if (auctionRoomAccount) {
                setAuctionRoom(new AuctionRoom(auctionRoomPda as web3.PublicKey, new BN(auctionRoomAccount.timeDenomination as BN).toNumber()))
            }
        }

        fetchAuctionRoom();

    }, [program, providerPda])

    useEffect(() => {
        async function fetchAuctionsAndAdCampaign() {
            if (!program || !providerPda || !auctionRoom) { return }

            const startTime = Math.floor(getTimestampInSeconds() / auctionRoom.timeDenomination) * auctionRoom.timeDenomination;
            const [auctionPda] = Auction.findAddress(new web3.PublicKey(providerPda), startTime);
            try {
                const auctionAccount = await program.account.auction.fetch(auctionPda)
                const auction = new Auction(
                    auctionPda,
                    new web3.PublicKey(providerPda),
                    new BN(auctionAccount.startTime as BN).toNumber(),
                    new BN(auctionAccount.startPrice as BN).toNumber(),
                    new BN(auctionAccount.minBidDelta as BN).toNumber(),
                    new BN(auctionAccount.expriation as BN).toNumber(),
                    new BN(auctionAccount.currentPrice as BN).toNumber(),
                    auctionAccount.active as boolean,
                    auctionAccount.reward as boolean,
                    auctionAccount.highestBidder as web3.PublicKey
                );
                const adCampaignAccount = await program.account.adCampaign.fetch(auction.highestBidder as web3.PublicKey);
                setAdCampaign(
                    new AdCampaign(
                        adCampaignAccount.id as number,
                        adCampaignAccount.name as string,
                        adCampaignAccount.link as string,
                        auction.highestBidder
                    )
                );

            } catch (err) {
                setAdCampaign(undefined)
            }
        }

        if (!auctionRoom) { return }
        const intervalId = setInterval(fetchAuctionsAndAdCampaign, 5000);

        return () => clearInterval(intervalId);

    }, [auctionRoom]);


    return (
        <div>
            {adCampaign && <img src={adCampaign.link} style={{ maxHeight: "150px" }} />}
        </div>
    );
};

export default IframeContent;